import * as React from "react"
import { useEditorState } from "@tiptap/react"
import { Button } from "../../tiptap-ui-primitive/button"
import { BoldIcon } from "../../tiptap-icons/bold-icon"
import { ItalicIcon } from "../../tiptap-icons/italic-icon"
import { UnderlineIcon } from "../../tiptap-icons/underline-icon"
import { StrikethroughIcon } from "../../tiptap-icons/strikethrough-icon"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"

type MarkType = "bold" | "italic" | "underline" | "strike" | "code"

const MARK_ICONS: Record<MarkType, React.FC<React.SVGProps<SVGSVGElement>>> = {
  bold: BoldIcon,
  italic: ItalicIcon,
  underline: UnderlineIcon,
  strike: StrikethroughIcon,
  code: BoldIcon, // placeholder
}

const MARK_LABELS: Record<MarkType, string> = {
  bold: "Жирный",
  italic: "Курсив",
  underline: "Подчёркнутый",
  strike: "Зачёркнутый",
  code: "Код",
}

export interface MarkButtonProps {
  type: MarkType
}

export const MarkButton: React.FC<MarkButtonProps> = ({ type }) => {
  const editor = useTiptapEditor()

  const state = useEditorState({
    editor,
    selector: (ctx) => ({
      isActive: ctx.editor?.isActive(type) ?? false,
      canToggle: ctx.editor?.can().toggleMark(type) ?? false,
    }),
  })

  const handleClick = () => {
    if (!editor) return
    editor.chain().focus().toggleMark(type).run()
  }

  const Icon = MARK_ICONS[type]
  const label = MARK_LABELS[type]

  return (
    <Button
      onClick={handleClick}
      data-active={state.isActive}
      data-disabled={!state.canToggle}
      disabled={!state.canToggle}
      aria-label={label}
      title={label}
    >
      <Icon className="tiptap-button-icon" />
    </Button>
  )
}
